export abstract class DatasetUsageDialogFacade {
  abstract openDatasetUsageModal(reportsCount: number): void;
}
